// extracted by mini-css-extract-plugin
export default {"section":"EmptyState_section__-5YtK"};